export const CookieService = {
  check(name) {
    return document.cookie.split(';').some(c => c.trim().startsWith(name + '='));
  },

  get(name) {
    const cookies = document.cookie.split(';');
    const cookie = cookies.find(c => c.trim().startsWith(name + '='));
    return cookie ? decodeURIComponent(cookie.split('=')[1]) : '';
  },

  getAll() {
    return document.cookie.split(';')
      .reduce((cookies, cookie) => {
        const [name, value] = cookie.split('=').map(c => c.trim());
        if (name) cookies[name] = decodeURIComponent(value);
        return cookies;
      }, {});
  },

  set(
    name,
    value,
    expires = undefined,
    path = '/',
    domain = null,
    secure = false,
    sameSite = 'Lax'
  ) {
    let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
      
    if (expires !== undefined) {
      if (typeof expires === 'number') {
        const dateExpires = new Date(new Date().getTime() + expires * 1000 * 60 * 60 * 24);
        cookie += `; expires=${dateExpires.toUTCString()}`;
      } else {
        cookie += `; expires=${expires.toUTCString()}`;
      }
    }

    if (path) cookie += `; path=${path}`;
    if (domain) cookie += `; domain=${domain}`;
    if (secure) cookie += '; secure';
    cookie += `; samesite=${sameSite}`;
    document.cookie = cookie;
  },

  delete(
    name,
    path = '/',
    domain = null,
    secure = false,
    sameSite = 'Lax'
  ) {
    let cookie = `${encodeURIComponent(name)}=; expires=${new Date(0).toUTCString()}`;
    if (path) cookie += `; path=${path}`;
    if (domain) cookie += `; domain=${domain}`;
    if (secure) cookie += '; secure';
    cookie += `; samesite=${sameSite}`;
    document.cookie = cookie;
  },

  deleteAll(path = '/', domain = null) {
    const cookies = this.getAll();
    Object.keys(cookies).forEach(name => {
      this.delete(name, path, domain);
    });
  }
};